module.exports = __webpack_public_path__ + "static/media/player6.1662810a.png";